import React from "react"
import autobind from "class-autobind"
import { TextField, Dialog, FlatButton, SelectField, MenuItem } from "material-ui"
import strings from "../../localization/strings"
import { EOTType, EOvertimeRuleType, IOTPolicy, IOvertimeRule } from "../../models"
import { EnumValues } from "enum-values"
import OvertimeRuleChip from "./overtimeRules/OvertimeRuleChip"
import * as utils from "../../helpers/utils"

interface IProps {
    editOTPolicy: IOTPolicy
    otPolicies: IOTPolicy[]
    handleAdd(otPolicy: IOTPolicy): void
    handleUpdate(otPolicy: IOTPolicy): void
    handleClose(): void
}
interface IState {
    name: string
    nameError: string
    type: EOTType
    overtimeRules: IOvertimeRule[]
    overtimeRulesError: string
}

export default class AddOTPolicyDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            name: props.editOTPolicy ? props.editOTPolicy.Name : "",
            nameError: "",
            type: props.editOTPolicy ? props.editOTPolicy.Type : EOTType.Weekly,
            overtimeRules: props.editOTPolicy && props.editOTPolicy.OvertimeRules ? props.editOTPolicy.OvertimeRules : [],
            overtimeRulesError: ""
        }
        autobind(this)
    }

    checkValidate() {
        let isValidate = true

        if (!this.state.name.trim()) {
            this.setState({ nameError: strings.This_field_is_required })
            isValidate = false
        }
        else if (this.props.otPolicies.filter(i => this.props.editOTPolicy ? i.Id !== this.props.editOTPolicy.Id : true).find(i => i.Name === this.state.name.trim())) {
            this.setState({ nameError: strings.Name_is_duplicated })
            isValidate = false
        }
        else {
            this.setState({ nameError: "" })
        }

        if (this.state.type !== EOTType.Bi_Weekly && this.state.overtimeRules.find(i => i.Type === EOvertimeRuleType.Bi_Weekly)) {
            this.setState({ overtimeRulesError: strings.Bi_Weekly_rule_should_be_not_exist })
            isValidate = false
        }
        else {
            this.setState({ overtimeRulesError: "" })
        }
        return isValidate
    }

    handleRequestSave() {
        if (!this.checkValidate()) return
        const otPolicy = this.props.editOTPolicy || { Id: utils.guid() } as IOTPolicy
        otPolicy.Name = this.state.name.trim()
        otPolicy.Type = this.state.type
        otPolicy.OvertimeRules = this.state.overtimeRules
        this.props.editOTPolicy ?
            this.props.handleUpdate(otPolicy) :
            this.props.handleAdd(otPolicy)
    }

    render() {
        return (
            <Dialog
                open
                title={this.props.editOTPolicy ? strings.Edit_OT_Policy : strings.New_OT_Policy}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton key="cancel" data-intercom-target={"menu-AccountSettings-PayConfiguration-OTPoliciesTab-Btn-CloseAddOTPolicyDialog"} label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton key="save" data-intercom-target={"menu-AccountSettings-PayConfiguration-OTPoliciesTab-Btn-SaveOTPolicy"} label={strings.SAVE} primary onTouchTap={this.handleRequestSave} />
                ]}
            >
                <hr />
                <div style={{ paddingLeft: 15 }}>
                    <TextField
                        data-intercom-target={"menu-AccountSettings-PayConfiguration-OTPoliciesTab-Add-Entry-Name"}
                        floatingLabelText={strings.Name}
                        value={this.state.name}
                        style={{ width: "95%" }}
                        onChange={(event, value) =>
                            this.setState({ name: value }, () =>
                                this.checkValidate()
                            )
                        }
                        errorText={this.state.nameError}
                        errorStyle={{ position: "absolute", bottom: -12 }}
                    />
                    <SelectField
                        floatingLabelText={strings.OT_Policy_Type}
                        value={this.state.type}
                        onChange={(event, key, type) => this.setState({ type }, () => this.checkValidate())}
                        disabled={this.props.editOTPolicy ? true : false}
                    >
                        {EnumValues.getValues(EOTType).map(i =>
                            <MenuItem key={i} value={i} primaryText={strings[EnumValues.getNameFromValue(EOTType, i)]} />
                        )}
                    </SelectField>
                    <div style={{ marginTop: 25 }}>
                        <OvertimeRuleChip
                            otType={this.state.type}
                            error={this.state.overtimeRulesError}
                            overtimeRules={this.state.overtimeRules}
                            handleChange={overtimeRules => this.setState({ overtimeRules }, () => this.checkValidate())}
                        />
                    </div>
                </div>
            </Dialog>
        )
    }
}